import { lazy, Suspense } from 'react'
import { SocialSkeleton } from './skeleton'
import { AppTabs, Tab } from '@/shared/ui/appTabs'
import { useStyles } from './styles'
import { LeaderboardSkeleton } from '@/widgets/leaders/skeleton'
import { Friends } from '@/widgets/friends'
import { useUnit } from 'effector-react'
import { $socialTab, changeSocialTab } from '@/entities/navigation'
import { lang } from '@/shared/constants/lang'
import { $userLanguage } from '@/entities/user'

const Referral = lazy(() => import('@/widgets/referral'))
const Leaders = lazy(() => import('@/widgets/leaders'))

export const SocialView = () => {
  const activeTab = useUnit($socialTab)
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.friends
  const { classes } = useStyles()

  const tabs: Tab[] = [
    { icon: 'socialFriends', label: texts.tabs.social, value: 0 },
    { icon: 'socialGigi', label: texts.tabs.gigi, value: 1 },
    { icon: 'socialReferrals', label: texts.tabs.referrals, value: 2 },
  ]
  return (
    <>
      {activeTab === 0 && (
        <Suspense fallback={<SocialSkeleton />}>
          <Friends />
        </Suspense>
      )}
      {activeTab === 1 && (
        <Suspense fallback={<LeaderboardSkeleton />}>
          <Leaders />
        </Suspense>
      )}
      {activeTab === 2 && (
        <Suspense fallback={<SocialSkeleton />}>
          <Referral />
        </Suspense>
      )}
      <div className={classes.tabsWrapper}>
        <AppTabs tabs={tabs} activeValue={activeTab} onChange={changeSocialTab} />
      </div>
    </>
  )
}
